// client/src/hooks/useMetodosPagamento.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const QUERY_KEY = 'metodosPagamento';

export const useMetodosPagamento = (accountId, options = {}) => {
    return useQuery({
        queryKey: [QUERY_KEY, accountId],
        queryFn: async () => {
            if (!accountId) return { data: [] };
            
            // ✅ CORREÇÃO: Enviar apenas o ID como string, não o objeto inteiro
            const accountIdStr = typeof accountId === 'object' 
                ? (accountId._id || accountId.id || JSON.stringify(accountId).replace(/[{}"]/g, ''))
                : String(accountId);
            
            console.log('🔍 [useMetodosPagamento] accountId enviado:', accountIdStr);
            
            const { data } = await apiClient.get('/metodos-pagamento', { 
                params: { account: accountIdStr } 
            });
            return data;
        },
        enabled: !!accountId && options.enabled !== false,
        ...options
    });
};

export const useMutateMetodosPagamento = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();

    const invalidateCache = () => {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    };

    const createMetodo = useMutation({
        mutationFn: (newData) => apiClient.post('/metodos-pagamento', newData),
        onSuccess: () => {
            invalidateCache();
            setAlert('Forma de pagamento criada com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao criar forma de pagamento', 'danger'),
    });

    const updateMetodo = useMutation({
        mutationFn: ({ id, updatedData }) => apiClient.put(`/metodos-pagamento/${id}`, updatedData),
        onSuccess: () => {
            invalidateCache();
            setAlert('Forma de pagamento atualizada com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao atualizar forma de pagamento', 'danger'),
    });
    
    const deleteMetodo = useMutation({
        mutationFn: (id) => apiClient.delete(`/metodos-pagamento/${id}`),
        onSuccess: () => {
            invalidateCache();
            setAlert('Forma de pagamento removida com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao remover forma de pagamento', 'danger'),
    });

    return { createMetodo, updateMetodo, deleteMetodo };
};